// Payment-collection schedule for AUTO-renewal policies, shown in the A21 email.
// Captured from rensure-sme-smp/lib/domain/collection.ts (days before renewal).

import type { PaymentType } from "./types";

export type CollectionRow = { day: number; label: string };

export const COLLECTION_SCHEDULE: Record<PaymentType, CollectionRow[]> = {
  // In Full
  CASH: [
    { day: 10, label: "1st attempt" },
    { day: 7, label: "2nd attempt (if needed)" },
    { day: 5, label: "3rd attempt" },
    { day: 3, label: "4th attempt" },
    { day: 1, label: "Final attempt" },
    { day: 0, label: "Final retry (renewal day, AM)" },
  ],
  // Direct Debit
  INSTALMENTS: [
    { day: 14, label: "1st attempt" },
    { day: 10, label: "2nd attempt" },
    { day: 7, label: "3rd attempt" },
    { day: 3, label: "4th attempt (if scheme/provider permits)" },
    { day: 1, label: "Final attempt (if operationally possible)" },
  ],
};

export const COLLECTION_LABEL: Record<PaymentType, string> = {
  CASH: "In Full",
  INSTALMENTS: "Direct Debit",
};
